// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__22ewp","options":"AnswerScale_options__3c4H6","selected":"AnswerScale_selected__j2Bjp"};